const IMG_PATTERN = /\{\{\s*['"]([^'"]+)['"]\s*\|\s*img(?::\s*(\d*\.?\d+))?\s*\}\}/;
const QR_CODE_PATTERN = /\{\{\s*['"]([^'"]+)['"]\s*\|\s*qr_code(?::\s*(\d*\.?\d+))?\s*\}\}/;

/**
 * @param {string} value
 * @returns {[string, number] | [null, null]}
 */
export const parseImage = (value) => {
  const match = value.match(IMG_PATTERN);

  return match ? [match[1], match?.[2] ? parseFloat(match[2]) : 1] : [null, null];
};

/**
 * @param {string} value
 * @returns {[string, number] | [null, null]}
 */
export const parseQrCode = (value) => {
  const match = value.match(QR_CODE_PATTERN);

  return match ? [match[1], match?.[2] ? parseFloat(match[2]) : 1] : [null, null];
};

/** @param {string} value */
export const isGradient = (value) => {
  if (!value || value.startsWith('http')) {
    return false;
  }

  const colors = value.split(',').map((c) => c.trim());

  return colors.length > 1 && colors.every((c) => /^#[0-9A-Fa-f]{3,6}$|^rgb/.test(c));
};

/** @param {string} value */
export const buildGradient = (value) => {
  const colors = value.split(',').map((c) => c.trim());
  const colorCycle = [...colors, colors[0]];

  return `radial-gradient(circle at center 75%, white, transparent), conic-gradient(from -90deg at center 75%, ${colorCycle.join(', ')})`;
};

/** @param {string} background */
export const getBackgroundStyle = (background) => {
  if (!background) {
    return undefined;
  }

  if (background.startsWith('http')) {
    return `url(${background}) top left / cover no-repeat`;
  }

  if (isGradient(background)) {
    return buildGradient(background);
  }

  return background;
};
